/**
 * @desc: Copied from https://git.perkbox.io/backend-services/identity-v2/blob/master/internal/errorLib/codes.go
 */
enum User {
  UserNotFoundErr = "PBIDEUserNotFound",
  EmailAlreadyExists = "PBIDEEmailAlreadyExists",
  EmailTooShort = "PBIDEEmailTooShort",
  EmailTooLong = "PBIDEEmailTooLong",
  EmailInvalid = "PBIDEEmailInvalid",
  RoleHierarchyCheckFailed = "PBIDERoleHierarchyCheckFailed",
  InvalidSettingKey = "PBIDEInvalidSettingKey",
  InvalidSettingType = "PBIDEInvalidSettingType",
  AddressValidationFailed = "PBIDEAddressValidationFailed",
  OneAddressMustBePrimary = "PBIDEOneAddressMustBePrimary",
  OnlyOnePrimaryAddress = "PBIDEOnlyOnePrimaryAddress",
  DOBInvalid = "PBIDEDOBInvalid",
  FirstnameTooShort = "PBIDEFirstnameTooShort",
  FirstnameTooLong = "PBIDEFirstnameTooLong",
  FirstnameInvalid = "PBIDEFirstnameInvalid",
  LastnameTooShort = "PBIDELastnameTooShort",
  LastnameTooLong = "PBIDELastnameTooLong",
  LastnameInvalid = "PBIDELastnameInvalid",
  GenderInvalid = "PBIDEGenderInvalid",
  PhoneTooShort = "PBIDEPhoneTooShort",
  PhoneTooLong = "PBIDEPhoneTooLong",
  PhoneInvalid = "PBIDEPhoneInvalid",
  SourceInvalid = "PBIDESourceInvalid",
  ProfileImageInvalid = "PBIDEProfileImageInvalid",
  UserDisabled = "PBIDEUserDisabled",
  TeamNotFoundErr = "PBIDETeamNotFound",
  TeamDoesNotBelong = "PBIDETeamDoesNotBelong",
  PhoneNumberAlreadyExists = "PBCOREPhoneNumberAlreadyExists",
  UserCreationRestricted = "PBCOREUserCreationRestricted"
}

export default User
